import React from "react";
import AppBanner from "@ui-kit/app-banner";
import { useVisibleBanner } from "@radarly/core/context/use-cases";
import { useCloseUserBanner } from "@radarly/core/user/use-cases";

const Component = () => {
  const banner = useVisibleBanner();
  const { closeUserBanner } = useCloseUserBanner();
  return (
    <>
      {!!banner && (
        <AppBanner
          sticky
          message={banner.message}
          onClose={() => closeUserBanner(banner.id)}
          type={banner.type}
        />
      )}
    </>
  );
};

export default Component;
